import React, { useContext } from 'react'
import { ShopContext } from '../../context/Shop-context';
import './cart.css'
import { Link } from 'react-router-dom';
import { ProductDetails } from '../ProductDetails/ProductDetails';
export const CartItem = (props) => {
    const {id, productName, price, productImg, category} = props.daa;
    const {cartItems, addToCart, removeFromCart, updateCartItemCount, getTotalCartAmount} =useContext(ShopContext)
    var qty = cartItems[id];
    var total = getTotalCartAmount()
    var cost =price;
  return (
    <div id='eachCartItem'>
        <div id='cartedItems' className=''>
            {/* <div id='imgContainer'> */}
                <Link to={`/ProductDetails/${id}`} className='m-auto text-black' element={<ProductDetails data={props.data}/>}    >
                <img id='cartImg' src={productImg}></img>
             {/* </div> */}
             </Link>

            <div><Link to={`/ProductDetails/${id}`} className='m-auto' element={<ProductDetails data={props.data}/>}    >
                <p style={{'margin-bottom':'10px'}}><b>{productName}</b></p>
                <p style={{'margin-bottom':'10px'}}> {'\u20B9'}{cost}</p>
                </Link>
                {/* <p> Qty : {qty}</p> */}
                <span>Qty: </span><button className='h-8 w-8 border border-gray-700' onClick={()=>removeFromCart(id)}> - </button>
                <input id='manual' value={qty} className='w-8 border m-auto p-1 mx-1 text-center' placeholder='Qty' onChange={((e)=>updateCartItemCount(Number(e.target.value),id))}/>
                <button className='h-8 w-8 border border-gray-700 mr-8' onClick={()=>addToCart(id)}> + </button>

                <p style={{'margin-top':'10px'}}> Total cost: {'\u20B9'}{qty*cost} </p>

            </div>
        </div>

    </div>

  )
}
